import React, { useEffect, useMemo, useState } from 'react';
import PropertyShow from './property_show';
import configureStore from 'bundles/connect/components/store/configure';
import { Provider } from 'react-redux';

type Props = {
  insightsPropertyId: string;
  hasProfile: boolean;
}

export default function PropertyShowContainer({ insightsPropertyId, hasProfile }: Props) {
  const [propertyId, setPropertyId] = useState(insightsPropertyId);

  const store = useMemo(() => configureStore(
    {
      offMarketProperty: {
        owners: null,
        propertyId: insightsPropertyId
      }
    }
  ), [propertyId]);

  // when user navigates back/forward, check the URL and reassign the propertyId
  useEffect(() => {
    const listener = (e) => {
      setPropertyId(e.state?.propertyId);
    };
    window.addEventListener('popstate', listener);

    return () => window.removeEventListener('popstate', listener);
  }, []);

  useEffect(() => {
    if (propertyId) {
      const newUrl = `/prospect/off_market_properties/${propertyId}`;
      if (history.state?.propertyId !== propertyId) {
        history.pushState({ propertyId }, '', newUrl);
      }
    }
  }, [propertyId]);

  useEffect(() => {
    const showPropertyDetails = (event) => {
      const { eventName, payload } = event?.data || {};

      if (['pn-property-details', 'off_market_property_show'].includes(eventName)) {
        setPropertyId(payload.id);
      }
    };

    window.addEventListener('message', showPropertyDetails);

    return () => window.removeEventListener('message', showPropertyDetails);
  }, []);

  return (
    <Provider store={store}>
      <PropertyShow
        fromConsole={false}
        fromTurbo={true}
        fullscreen={true}
        hasProfile={hasProfile}
        inRethink={false}
        insightsPropertyId={propertyId}
      />
    </Provider>
  );
}
